module.exports = "pegasus/assets/hexline-linkedin.png";